import React from 'react';
import { ConsentPageI18n } from '../../i18n';
import { SectionSubtitle, TextConditions } from './style';
import { Subtitle } from '../../components/titles';
import styled from 'styled-components';
import { MarginTop10 } from '../../components/margins';

export const FastSwitchCompleteText = () => (
    <React.Fragment>
        <TextConditions>{ConsentPageI18n.fastSwitchConditionsShort}</TextConditions>
        <TextConditions>{ConsentPageI18n.fastSwitchConditions}</TextConditions>
    </React.Fragment>
);

export const AcceptContractText = () => (
    <React.Fragment>
        <SectionSubtitle>{ConsentPageI18n.acceptContract} <br /><br />{ConsentPageI18n.acceptContractA}<br /><br />{ConsentPageI18n.acceptContractB}<br /></SectionSubtitle>
    </React.Fragment>
);

export const VessatorieText = () => (
    <React.Fragment>
        <SectionSubtitle>{ConsentPageI18n.acceptVessatorieText}</SectionSubtitle>
    </React.Fragment>
);

export const FreeMarketText = () => (
    <React.Fragment>
        <SectionSubtitle>{ConsentPageI18n.acceptFreeMarketDescription}</SectionSubtitle>
        <ul>
            <li><Text>{ConsentPageI18n.acceptFreeMarketFirstEntry}</Text></li>
            <li><Text>{ConsentPageI18n.acceptFreeMarketSecondEntry}</Text></li>
        </ul>
    </React.Fragment>
);

const Text = styled(Subtitle)`
    font-size: 15px;
    ${MarginTop10};
`;